import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FieldConfig } from '../../models/common-models';
import { Field } from '../../models/field.interface';
import { MAT_DATE_FORMATS } from '@angular/material/core'
import { LayoutService } from '../../../../layout/layout.service';
import { GuestService } from 'src/app/shared/services/guest.service';
@Component({
    selector: 'app-form-date',
    templateUrl: './form-date.component.html',
    styleUrls: ['form-date.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [{ provide: MAT_DATE_FORMATS, deps: [LayoutService], useFactory: (layoutService) => layoutService.getDateFormats() }],
    standalone: false
})

export class FormdateComponent implements Field, OnInit, OnDestroy {
  public FormControlName;
  config: FieldConfig;
  group: UntypedFormGroup;
  _minDate: Date;
  today = new Date();
  hideTodayButton: boolean = false;
  subscriptions: Subscription = new Subscription();

  constructor(public gs: GuestService) { }

  ngOnInit() {

    return;
  }
 

  ngOnDestroy(): void {
    if (this.subscriptions) { this.subscriptions.unsubscribe(); }
  }
}

